import React from 'react'; 
import WithConsumer from '../context/WithConsumer';
import PageBlock from './PageBlock';
import Foot from './Foot';

const Page = ({ context }) => {
	
	let results = '';
	let pageBlocks = '';
	 
    const posts = () => context.posts;
    const post = posts()[0];
    
    const ctxPageLoaded = () => context.pageLoaded;
    const pageLoaded = ctxPageLoaded();
    
    const ctxDoRender = () => context.doRender;
	const doRender = ctxDoRender();
		
    let pageClass = 'c-page-wrapper state-not-loaded';
    if (pageLoaded == true) {
	    pageClass = 'c-page-wrapper state-loaded';
    }
    
    if (post && doRender) {
    	
    	if (post.block) {
		    const blocks = post.block; 
		
			if (context.appError){
				results = <div className="app-error">{context.appError}</div>;      
			} else {
				if (blocks.length === 0){
					results = null;
				} else{ 
					pageBlocks = blocks.map(function(block,i){
						return <PageBlock key={i} index={i}></PageBlock>
					})
					results = <div className={pageClass}>{pageBlocks}<Foot></Foot></div>
				}
			}
		} else {
			return null;
		}
	} else {
		results = null;
	}
	return (results);

};
export default WithConsumer(Page);